export const Title = (props: { title: string }) => {
  const { title } = props;
  return (
    <div className="h-[20px] leading-[22px] text-[14px] text-[#232426] font-bold pl-[12px] relative">
      <div className="absolute w-[3px] h-[14px] top-[4px] left-0 bg-[#3370ff]"></div>
      {title}
    </div>
  );
};
